// src/services/ConfiguracionService.js
import fetch from 'auth/FetchInterceptor';

const ConfiguracionService = {};

/**
 * Listado de configuraciones. Se filtra por nivel y referencia:
 *   - nivel=empresa  + referencia_id={empresaId}  → horarios de la empresa
 *   - nivel=empleado + referencia_id={empleadoId} → override del empleado
 */
ConfiguracionService.getAll = function (params = {}) {
    return fetch({
        url: '/v1/config',
        method: 'get',
        params,
    });
};

/**
 * Horarios disponibles para asignar a un empleado: las configuraciones
 * de nivel `empresa` de la empresa indicada (CRUD estándar de la
 * Sección 6.1 sobre el recurso `config`, módulo Configuración).
 */
ConfiguracionService.getHorariosEmpresa = function (empresaId, params = {}) {
    return fetch({
        url: '/v1/config',
        method: 'get',
        params: { nivel: 'empresa', referencia_id: empresaId, per_page: 100, ...params },
    });
};

/**
 * Override de nivel empleado, si existe. El backend devuelve un
 * listado, así que se toma el primero (solo puede haber uno por
 * empleado en la práctica).
 */
ConfiguracionService.getOverrideEmpleado = function (empleadoId) {
    return fetch({
        url: '/v1/config',
        method: 'get',
        params: { nivel: 'empleado', referencia_id: empleadoId },
    });
};

/**
 * Configuración efectiva de un empleado (override propio sobre el de su
 * empresa). Devuelve `valores`, `origen` (propio | heredado | default
 * por campo) y `fuentes`. El `origen` alimenta el indicador visual de
 * herencia que pide la Sección 7.5 del documento.
 */
ConfiguracionService.getResuelta = function (empleadoId) {
    return fetch({
        url: '/v1/config/resuelta',
        method: 'get',
        params: { empleado_id: empleadoId },
    });
};

// ── Escritura por nivel (upsert: crea o actualiza) ──────────────

ConfiguracionService.guardarEmpresa = function (empresaId, data) {
    return fetch({
        url: `/v1/config/empresa/${empresaId}`,
        method: 'put',
        data,
    });
};

ConfiguracionService.guardarEmpleado = function (empleadoId, data) {
    return fetch({
        url: `/v1/config/empleado/${empleadoId}`,
        method: 'put',
        data,
    });
};

// ── CRUD genérico (usado para los turnos asignables) ────────────

ConfiguracionService.create = function (data) {
    return fetch({
        url: '/v1/config',
        method: 'post',
        data,
    });
};

ConfiguracionService.update = function (id, data) {
    return fetch({
        url: `/v1/config/${id}`,
        method: 'put',
        data,
    });
};

ConfiguracionService.remove = function (id) {
    return fetch({
        url: `/v1/config/${id}`,
        method: 'delete',
    });
};

export default ConfiguracionService;
